/**
 * Global Tabs Component Exports
 *
 * @since 1.0.0
 */

export { GlobalTabs } from './component';
